import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

/**
 * Sends a GA4 page_view event on every SPA route change.
 * Uses a small delay so document.title (set by react-helmet-async) is updated first.
 */
export function useAnalyticsPageView() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    const id = window.setTimeout(() => trackPageView(path), 50);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);
}

const AnalyticsRouteTracker = () => {
  useAnalyticsPageView();
  return null;
};

export default AnalyticsRouteTracker;
